import axios from "axios";

export const BASE_URL = `${process.env.REACT_APP_API_URL}/api`;
export const FILE_URL = process.env.REACT_APP_API_URL;

// Create Axios instance
export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

export const jobApi = {
  getJobs: async (page = 1, limit = 20, search) => {
    let url = `/jobs?page=${page}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    const res = await api.get(url);
    return res.data;
  },

  getJobById: async (id) => {
    const res = await api.get(`/jobs/${id}`);
    return res.data;
  },

  createJob: async (job) => {
    const res = await api.post("/jobs/", job);
    return res.data;
  },

  updateJob: async (id, job) => {
    const res = await api.put(`/jobs/${id}`, job);
    return res.data;
  },

  deleteJob: async (id) => {
    const res = await api.delete(`/jobs/${id}`);
    return res.data;
  },
};
//metadata
export const getMetadataByPage = async (page) => {
  try {
    const response = await api.get(`/metadata/${page}`);
    console.log("Metadata fetched");
    return response.data;
  } catch (error) {
    console.error("Error fetching metadata:", error);
    return null;
  }
};
// Testimonials
export const testimonialApi = {
  getTestimonials: async () => {
    const res = await api.get("/testimonials");
    return res.data;
  },
};

// Employers
export const employersApi = {
  createEmployer: async (formData) => {
    const res = await api.post("/employers", formData);
    return res.data;
  },
};

// Contacts
export const contactsApi = {
  createContact: async (formData) => {
    const res = await api.post("/contacts", formData);
    return res.data;
  },
};

// Candidate Form Api
export const candidateApi = {
  submitCandidateForm: async (formDataObj) => {
    const formData = new FormData();

    for (let key in formDataObj) {
      formData.append(key, formDataObj[key]);
    }

    const res = await axios.post(`${BASE_URL}/candidateform`, formData, {
      headers: {
        // Don't set Content-Type manually for FormData
        "ngrok-skip-browser-warning": "true",
      },
    });

    return res.data;
  },
};

// Employee Form
export const employeeApi = {
  submitEmployeeForm: async (formDataObj) => {
    const formData = new FormData();

    for (let key in formDataObj) {
      formData.append(key, formDataObj[key]);
    }

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/employeeform`,
      // Do NOT set Content-Type manually; Axios will handle it
      formData,
      {
        headers: {
          "ngrok-skip-browser-warning": "true",
        },
      }
    );

    return res.data;
  },
};
